import { IClaioSchemaImageSource } from ".";

export class ClaioSchemaItem {
  templateId: number;
  groupId: number;
  itemId: number;
  description: string;
  imageSource: IClaioSchemaImageSource;

  /**
   * Vueに配列をbindしたときのkey
   */
  get key(): string {
    return this.templateId + "-" + this.groupId + "-" + this.itemId;
  }
}
